module.exports = __webpack_public_path__ + "img/bc24b8d.jpg";